import { Form, Input } from 'antd';
import React, { useState } from 'react';
import FormPage from '../../../../../components/pages/FormPage';

const DefModel = {
    nama: '',
    kode_warehouse: '',
    kode_tps: '',
    address: ''
}

export default () => {
    const [model, setModel] = useState(DefModel);
    return (
        <FormPage
            url={'api/v1/warehouse'}
            formValid={false}
            model={model}
            setModel={setModel}
            wrapperCol={{ span: 8 }}
            labelCol={{ span: 3 }}
            title={"Warehouse"}
            emptyModel={DefModel}
            callbackPath={"/master/warehouse"}
        >
            <Form.Item name={'nama'} label="Nama" rules={[{ required: true }]} >
                <Input autoComplete="off" onInput={e => e.target.value = e.target.value.toUpperCase()} autoFocus />
            </Form.Item>
            <Form.Item name={'kode_warehouse'} label="Kode Warehouse" rules={[{ required: true }]} >
                <Input autoComplete="off" onInput={e => e.target.value = e.target.value.toUpperCase()} />
            </Form.Item>
            <Form.Item name={'kode_tps'} label="Kode TPS" rules={[{ required: true }]} >
                <Input autoComplete="off" onInput={e => e.target.value = e.target.value.toUpperCase()} />
            </Form.Item>
            <Form.Item name={'address'} label="Address" >
                <Input.TextArea autoComplete="off" rows={3} />
            </Form.Item>
        </FormPage>
    )
}
